// import axios, {AxiosError, AxiosResponse} from "axios";
import Api from '../../helpers/Api';
import { VIPDonationToken } from '../../interface/Server';


type VIPDonationParams = {
    donationId: number | string,
    accessKey: number | string,
}

interface VIPDonationResponse {
    code: number,
    msg: string,
    data: VIPDonationToken,
}

//: Promise<VIPDonationResponse | false> 

export const vipDonation = ({ donationId, accessKey }: VIPDonationParams)=> {
    const query = new URLSearchParams();
    query.append('accessKey', `${accessKey}`);
    query.append('donationId', `${donationId}`);

    const headers = {
        'Content-Type': "application/json; charset=utf-8",
    };
    return fetch(`${Api.path(window.location)}donate/review?` + query.toString(), {
        method: 'GET',
        headers: headers
    }).then(function (res) {
        sessionStorage.removeItem('auth');
        sessionStorage.removeItem('SAVED_FORM_DETAILS');
        sessionStorage.setItem('auth', res.headers.get('authorization') || '');
        return res.json();
    }).then(function (res) {
        return res;
    })
    .catch(function (error) {
        return false;
    });

    
    // axios.get('/donate/asset/review?' + query.toString()).then(
    // // return axios.get('/donate/asset/review?' + query.toString()).then(
    //     (res: AxiosResponse) => {
    //         console.log('AxiosResponse', res);
    //         return res;
    //     }
    // ).catch((err: AxiosError) => {
    //     const { response } = err;
    //     if(response && response.data && response.data.msg) {
    //         console.log('Error message at vipDonation: ', response.data.msg);
    //         return {
    //             msg: response.data.msg
    //         };
    //     } else {
    //         console.log('Unknown error at vipDonation: ', err.message);
    //         return false;
    //     }
    // });
}